import CountryActions from './Actions'
import { Chip, Box, Tooltip } from '@mui/material'

export const getColumns = (onEdit, onDelete, onRefresh) => [
  { field: 'id', headerName: 'ID', headerAlign: 'center', width: 70 },
  {
    field: 'icono_svg',
    headerName: 'Ícono',
    headerAlign: 'center',
    width: 70,
    sortable: false,
    renderCell: params =>
      params.value ? (
        <Tooltip title="Ícono SVG">
          <Box
            sx={{ width: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            dangerouslySetInnerHTML={{ __html: params.value }}
          />
        </Tooltip>
      ) : (
        <Box sx={{ color: 'text.disabled', fontSize: 12 }}>—</Box>
      ),
  },
  {
    field: 'nombre',
    headerName: 'Nombre',
    headerAlign: 'center',
    flex: 2,
    minWidth: 160,
  },
  {
    field: 'slug',
    headerName: 'Slug',
    headerAlign: 'center',
    flex: 1.2,
    minWidth: 120,
  },
  {
    field: 'codigo_iso2',
    headerName: 'ISO2',
    headerAlign: 'center',
    flex: 0.8,
    minWidth: 80,
  },
  {
    field: 'codigo_iso3',
    headerName: 'ISO3',
    headerAlign: 'center',
    flex: 0.8,
    minWidth: 80,
  },
  {
    field: 'label_n1',
    headerName: 'Etiqueta N1',
    headerAlign: 'center',
    flex: 1.2,
    minWidth: 120,
  },
  {
    field: 'label_n2',
    headerName: 'Etiqueta N2',
    headerAlign: 'center',
    flex: 1.2,
    minWidth: 120,
  },
  {
    field: 'label_n3',
    headerName: 'Etiqueta N3',
    headerAlign: 'center',
    flex: 1.2,
    minWidth: 120,
  },
  {
    field: 'center',
    headerName: 'Centro (lat, lng)',
    headerAlign: 'center',
    flex: 1.4,
    minWidth: 140,
    sortable: false,
    renderCell: params =>
      params.value
        ? <Box sx={{ fontSize: 12, fontFamily: 'monospace' }}>{params.value[1]}, {params.value[0]}</Box>
        : <Box sx={{ color: 'text.disabled', fontSize: 12 }}>—</Box>,
  },
  {
    field: 'zoom',
    headerName: 'Zoom',
    headerAlign: 'center',
    flex: 0.6,
    minWidth: 70,
    type: 'number',
  },
  {
    field: 'orden',
    headerName: 'Orden',
    headerAlign: 'center',
    flex: 0.6,
    minWidth: 80,
    type: 'number',
  },
  {
    field: 'habilitado',
    headerAlign: 'center',
    headerName: 'Estado',
    flex: 1,
    minWidth: 100,
    renderCell: params => (
      <Chip
        label={params.value ? 'Activo' : 'Inactivo'}
        color={params.value ? 'success' : 'default'}
        size="small"
        variant="outlined"
      />
    ),
  },
  {
    field: 'actions',
    headerAlign: 'center',
    headerName: 'Acciones',
    type: 'actions',
    renderCell: params => (
      <CountryActions {...{ params, onEdit, onDelete, onRefresh }} />
    ),
    minWidth: 150,
    flex: 1.5,
  },
]
